export const LIST_ATTRIBUTES = "LIST_ATTRIBUTES";
export const ADD_ATTRIBUTE = "ADD_ATTRIBUTE";
export const DELETE_ATTRIBUTE = "DELETE_ATTRIBUTE";
export const ATTRIBUTE_ERROR = "ATTRIBUTE_ERROR"